import http from './http';

export default {
  retailListing: {
    get(analysisId) {
      return http().get(`/v1/retail_listing_selling_infos/${analysisId}`);
    },
    create(data) {
      return http().post(`/v1/retail_listing_selling_infos`, data);
    },
    update(data) {
      return http().put(`/v1/retail_listing_selling_infos/${data.id}`, data);
    },
    delete(analysisId) {
      return http().delete(`/v1/retail_listing_selling_infos/${analysisId}`);
    },
  },
}
